import { gql } from "@apollo/client"
    
const GET_SITE_META_DATA = gql`
  query ($clientId: ID!) {
    client(id: $clientId) {
      id
      data_age
      import_scheduled
      
      importType {
        id
        name
        code
      }

      latestImport {
        id
        created_at
        status {
          id
          code
          description
        }
      }
    }

    dataCounts(client_id: $clientId) {
      guardian_counts
      lesson_counts
      staff_counts
      student_counts
      subject_counts
      is_complete
    }
  }
`
    
export { GET_SITE_META_DATA }
